    <div class="container" style="margin-top: 15px;">
         <div class="row">
              <div class="col-lg-12 header">
                <span>
                   <h1 class="text-dark">
                     <img src="./assets/img/logo.jpg" alt="Jane" width=100 />
                     2020 ELECTION
                    <small>Mizoram CSC-VLE Association</small>
                  </h1>
                </span>
              </div>
         </div>
    </div>
	<div class="container" style="margin-top: 15px;">
		<div class="row">
		  <div class="col-sm-3">
			 <div class="row">
				<div class="card bg-light col-lg-12">
				  <div class="card-body leftbo">
				    <h5 class="card-title">Voter Profile</h5>
				    <p class="card-text" *ngFor="let data of data">
				    	<span style="display: block;">Name: {{data.fullName}}</span>
				    	<span style="display: block;">Location: {{data.location}}</span>
				    	<span style="display: block;">Contact: {{data.phoneNumber}}</span>
				    	<span style="display: block;">CSC ID: {{data.cscid}}</span>
				    </p>
				  </div>
				</div>
			</div>
			<div class="row">
				<div class="card bg-light col-lg-12" style="margin-top: 5px;">
				  <div class="card-body leftbo" *ngIf="!casted">
				    <h5 class="card-title">Voting Rules</h5>
				    	<ol>
				    		<li>Voter must select 6 candidates.</li>
				    		<li>Submit your votes after selecting your candidate(s).</li>
				    		<li>Vote submission can be done only once.</li>
				    	</ol>
				  </div>
				  <div class="card-body leftbo" *ngIf="casted">
				    <h5 class="card-title">You have already casted your votes</h5>
				  </div>
				</div>
		  	</div>
			<div class="row">
				<div class="card bg-light col-lg-12" style="margin-top: 5px;">
				  <div class="card-body leftbo">
				  	<button class="btn btn-block btn-primary" (click)="goout()"> Logout </button>
				  </div>
				</div>
		  	</div>

		  </div>
		  <div class="col-sm-5">
			<div class="card bg-light" *ngIf="!casted">
			  <div class="card-body leftbo">
			    <h5 class="card-title rbo">Candidate's list</h5>
			    <table class="table">
			    	<tbody>
			    		<tr *ngFor="let r of rdata">
			    			<td><img src="{{r.image}}" style="width: 60px; border: 3px solid #e3e3e3; border-radius: 10px;" />
			    			</td>
			    			<td>
						    	<span style="display: block;">{{r.fullName}}</span>
						    	<span style="display: block;">{{r.location}}</span>			    				
			    			</td>
			    			<td>
			    				<button class="btn btn-success" (click)="addVote(r)">Vote</button>
			    			</td>
			    		</tr>			    		
			    	</tbody>
			    </table>
			  </div>
			</div>
			<div class="card bg-light" *ngIf="casted">
			  <div class="card-body leftbo">
			    <h5 class="card-title rbo">Your Votes</h5>
			    <table class="table">
			    	<tbody>
			    		<tr *ngFor="let v of voted; index as i">
			    			<td>{{i+1}}
			    			</td>
			    			<td>
						    	<span style="display: block;">{{v.vote}}</span>
			    			</td>
			    		</tr>			    		
			    	</tbody>
			    </table>
			  </div>
			</div>

		  </div>
		  <div class="col-sm-4">
			<div class="card bg-light" *ngIf="!casted">
			  <div class="card-body leftbo">
			    <h5 class="card-title rbo">My Votes</h5>
			    <table class="table">
			    	<tbody>
			    		<tr *ngFor="let v of myvotes; index as i">
			    			<td>
						    	<span style="display: block;">{{i+1}}. {{v.fullName}}</span>
			    			</td>
			    			<td>
			    				<button class="btn btn-danger" (click)="delVote(v)"><i class="fa fa-trash"></i>
			    				</button>
			    			</td>
			    		</tr>			    		
			    	</tbody>
			    </table>
			  </div>
			  <div class="card-footer" *ngIf="ready">
			  	<div *ngIf="enableVote">
				  	<button class="btn btn-primary" (click)="castVote()">Cast Vote</button>			  		
			  	</div>
			  	<div *ngIf="!enableVote">
			  		VOTE SUNMISSION HAS NOT YET STARTED
			  	</div>

			  </div>
			</div>
		  </div>

		</div>
	</div>
